'use client'

const throttleWindowMs = 300

const original = window.history.replaceState

let lastCallTime = 0
let globalTimeout: ReturnType<typeof setTimeout> | undefined = undefined

const callOriginal = (self: any, ...args: Parameters<typeof original>) => {
  lastCallTime = Date.now()
  original.apply(self, args)
}

window.history.replaceState = function (...args) {
  const now = Date.now()
  const msSinceLastCall = now - lastCallTime

  if (msSinceLastCall < throttleWindowMs) {
    if (globalTimeout !== undefined) {
      clearTimeout(globalTimeout)
    }

    const msToWait = throttleWindowMs - msSinceLastCall

    globalTimeout = setTimeout(() => {
      callOriginal(this, ...args)
      globalTimeout = undefined
    }, msToWait)
  } else {
    callOriginal(this, ...args)
  }
}
